import React from 'react';
import { Card, CardHeader, CardContent, IconButton, Button, Modal, Stack, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const EditTransaction = ({ open, handleClose, transaction, setTransactions }) => {
  const [title, setTitle] = React.useState(transaction.title);

  const handleClick = () => {
    setTransactions(prev => prev.map(t => {
      if (t.id !== transaction.id) {
        return t;
      }

      return { ...t, title };
    }));
    handleClose();
  };

  const handleChange = e => setTitle(e.target.value);

  return (
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Card sx={{ ...style, width: '40vw' }}>
        <CardHeader
          title="Edytuj transakcje"
          action={
            <IconButton color="primary" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          }
        />
        <CardContent>
          <Stack spacing={4}>
            <Stack spacing={2}>
              <Stack direction="row" justifyContent="left" spacing={4}>
                <Typography variant="body2">data: <span style={{ fontWeight: 'bold' }}>{transaction.entry_date}</span></Typography>
                <Typography variant="body2">kwota: <span style={{ fontWeight: 'bold' }}>{transaction.amount.amount}</span></Typography>
              </Stack>
              <Stack>
                <Typography variant="body2">Kontrahent: <span style={{ fontWeight: 'bold' }}>{transaction.contractor}</span></Typography>
              </Stack>
            </Stack>
            <TextField
              label="Tytyuł"
              value={title}
              onChange={handleChange}
            />
            <Button variant="contained" onClick={handleClick}>Edytuj</Button>
          </Stack>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default EditTransaction;

